/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ContactTermsPayables, SystemVarsRestService } from '@gh/builder-shared-data';

import { DictionaryService, InitViewService } from '@gh/common-shared';
import { map$ } from '@gh/rx/operators';

import { Observable } from 'rxjs';

import {
  SystemVarsPayables,
  systemVarsPayablesFromDto,
  systemVarsPayablesToDto,
} from './model/system-vars-payables.model';

@Injectable()
export class SystemVarsPayablesTabBusinessService implements InitViewService {
  constructor(private restService: SystemVarsRestService,
              private dictionaryService: DictionaryService) {
  }

  initView(): any {
    return {
      payablesSystemVariables: this.get(),
      termsPayables: this.dictionaryService.getByEnum(ContactTermsPayables),
    };
  }

  get(): Observable<SystemVarsPayables> {
    return this.restService.getPayables().pipe(map$(systemVarsPayablesFromDto));
  }

  update(payables: SystemVarsPayables): Observable<SystemVarsPayables> {
    return this.restService
      .updatePayables(systemVarsPayablesToDto(payables)).pipe(
        map$(systemVarsPayablesFromDto));
  }
}
